<template>
  <InterfaceCard
      icon="mdi-account-group"
      title="Выберите группу из списка"
  >
    <template v-slot:subtitle>
      Группы, в которых вы оставляли заказы
    </template>

    <v-row v-if="resolved">
      <v-col
          v-for="source in sources"
          :key="source.id"
          class="d-flex child-flex"
          cols="6"
          sm="4"
          md="2"
          lg="2"
      >
        <v-img
            :src="source.preview"
            class="grey lighten-2 pointer"
            aspect-ratio="1"
            @click="toBuyouts(source)"
        >
          <template v-slot:default>
            <div class="tile-title">
              <v-row class="fill-height my-0 mx-3" align="center">
                {{source.title}}
              </v-row>
            </div>
          </template>
          <template v-slot:placeholder>
            <v-row
                class="fill-height ma-0"
            >
              <v-skeleton-loader type="image">
              </v-skeleton-loader>
            </v-row>
          </template>
        </v-img>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col
          v-for="i in 6"
          :key="i"
          class="d-flex child-flex"
          cols="6"
          sm="4"
          md="2"
          lg="2"
      >
        <v-skeleton-loader type="image">
        </v-skeleton-loader>
      </v-col>
    </v-row>

    <Info
        v-if="resolved && !error && !sources.length"
        message="Группы не найдены"
        sub-message="Они появятся здесь сразу-же, как только Вам будет выставлен первый счет"
    ></Info>

    <Info
        v-if="error"
        :error="error"
    ></Info>
  </InterfaceCard>
</template>

<script>
import Info from '@/components/Info'
import InterfaceCard from '@/components/InterfaceCard'
import {appStates} from '@/constants'
export default {
  name: 'SourceSelector',
  components: {
    Info, InterfaceCard
  },
  data () {
    return {
      error: null,
      resolved: false,
      sources: []
    }
  },
  methods: {
    toBuyouts (source) {
      this.$router.push({
        name: appStates.sourceItemContent.name,
        params: {sourceId: source.ownerId}, query: {adminLevel: source.adminLevel}
      })
    }
  },
  mounted: function () {
    this.$client.get(this.$API.SOURCES.LIST)
        .then(data => this.sources = data.sources)
        .catch(err => this.error = err)
        .then(() => this.resolved = true)
  }
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.tile-title {
  background: rgba(0,0,0,.45);
  color: white;
  position: absolute;
  bottom: 0;
  height: 48px;
  width: 100%;
}
</style>
